import React, { useState } from 'react';
import { NoPackageAvailable } from '../../../assets/images';
import EmptyListCard from './EmptyListCard';
import DSIcon from './DSIcon';

const PreEmpPackageSelector = ({options=[], handleSelect, availablity_check = false}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedName, setSelectedName] = useState('')

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const getName = (id) => {
    let item = options.find(item => item.id === id)
    return item.name
  }

  const handleOptionSelect = (option) => {
    handleSelect(option)
    setSelectedName(getName(option))
    setSelectedOption(option);
    setIsOpen(false);
  };

  const getList = () => {
    return options.map((option, i) => {
      const disabled = availablity_check && (!(option?.prev_split_availed ?? true) || (option?.current_package_availed ?? false));
      return (
        <div key={option.id} onClick={() => (!disabled) ? handleOptionSelect(option.id) : null} className={`px-3 py-1 hover:bg-gray-100 w-full my-1 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
          { option.name }
        </div>
      )}
    )
  }

  const getEmptyList = () => {
    return (
          <EmptyListCard
            svgsrc={NoPackageAvailable}
            svgClasses='h-16'
            classes='my-4'
            title='No packages found'
            subTitleClasses='w-72'
            subTitle='Currently there are no packages available for this person in this category.'
            />
            )
  }

  return (
    <div className=''>
      <div className='flex min-h-[44px] cursor-pointer items-center rounded-ds-md border border-gray-275 bg-white px-3 py-2.5 transition-colors duration-150 hover:border-gray-400'>
        <input
          className={`select w-full cursor-pointer bg-transparent pr-3 text-[13px] ${selectedName.length > 0 ? 'font-medium text-gray-700' : 'font-medium text-gray-400'}`}
          style={{ borderColor: 'transparent'}}
          type="text"
          value={selectedName ? selectedName : ''}
          placeholder="Select a package"
          readOnly
          onClick={toggleDropdown}
        />
        <button type='button' aria-label='Toggle package list' className='inline-flex h-8 w-8 items-center justify-center rounded-[10px] text-gray-500' onClick={toggleDropdown}>
          <DSIcon name={isOpen ? 'chevron-up' : 'chevron-down'} size={16} />
        </button>
      </div>
      {isOpen && (
        <div className={`my-2 w-full overflow-auto scroll-smooth rounded-ds-md border border-gray-300 bg-white text-ts-md text-gray-600 shadow-ds-lg ${options.length > 4 ? 'h-44' : 'h-auto'}`}>
          {options.length > 0 ? getList() : getEmptyList()}
        </div>
      )}
    </div>
  );
};

export default PreEmpPackageSelector;
